import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { GrupoFamiliarDetailComponent } from './grupo-familiar-detail.component';
import { GrupoFamiliarListComponent } from './grupo-familiar-list.component';
import { GrupoFamiliarListSelectionComponent } from './grupo-familiar-list-selection.component';
import { GrupoFamiliarService } from './grupo-familiar.service';
import { QuestionarioDinamicoModule } from 'unb-questionario-componente';
import { RespostaListaDinamicaService } from 'unb-questionario-componente';
import { RespostaListaModule } from 'unb-questionario-componente';
import { PagerComponent} from '../paginator/pager.component';
import { ConfirmacaoDialogModule } from '../util/confirmacao.dialog.module';
import { ValidacaoMensagemModule } from '../validacao/validacao.mensagem.module';

/** AngularMaterial **/
import { MatSelectModule, MatButtonModule, MatIconModule, MatInputModule, MatRadioModule, MatProgressBarModule, MatSnackBarModule, MatTabsModule, MatCheckboxModule, MatDialogModule, MatListModule } from '@angular/material';
import { GrupoFamiliarVisualizarComponent } from './grupo-familiar-visualizar.component';
/**
Lista de Componentes do MaterialDesign (importar somento o q for usar)
MaterialModule, MdAutocompleteModule, MdCheckboxModule, MdInputModule, MdRadioModule, MdSelectModule, MdSliderModule, MdSlideToggleModule, MdMenuModule, MdSidenavModule, MdToolbarModule, MdListModule, MdGridListModule, MdCardModule, MdTabsModule, MdButtonModule, MdButtonToggleModule, MdChipsModule, MdIconModule, MdProgressSpinnerModule, MdDialogModule, MdTooltipModule, MdSnackBarModule
**/

@NgModule({
    declarations: [
      GrupoFamiliarDetailComponent,
      GrupoFamiliarListComponent,
      GrupoFamiliarListSelectionComponent, 
      GrupoFamiliarVisualizarComponent
    ],
    exports: [
      GrupoFamiliarDetailComponent,
      GrupoFamiliarListComponent,
      GrupoFamiliarListSelectionComponent,
      GrupoFamiliarVisualizarComponent
    ],
    imports: [
      FormsModule, CommonModule,
      QuestionarioDinamicoModule,
      RespostaListaModule,
      ConfirmacaoDialogModule,
      ValidacaoMensagemModule,
      MatSelectModule, MatButtonModule, MatIconModule, MatInputModule, MatProgressBarModule, MatSnackBarModule, MatRadioModule, MatTabsModule, MatCheckboxModule,MatDialogModule, MatListModule
    ],
    providers: [
      PagerComponent, RespostaListaDinamicaService, GrupoFamiliarService,
    ]
})
export class GrupoFamiliarModule {
}
